import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router, UrlSerializer } from '@angular/router';
import { LinkService } from '@core/jss-seo';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PaginationService {
  constructor(
    private readonly router: Router,
    private readonly linkService: LinkService,
    private readonly urlSerializer: UrlSerializer
  ) {}

  defaultPageNumber = 1;
  parseBase = 10;

  currentPage$: Observable<number> = inject(ActivatedRoute).queryParams.pipe(
    map((params) =>
      !isNaN(parseInt(params['page'], this.parseBase))
        ? parseInt(params['page'], this.parseBase)
        : this.defaultPageNumber
    )
  );

  public async initPagination(pageNumber: number, maxNumberOfPages: number) {
    const previousPage = pageNumber > 1 ? pageNumber - 1 : null;
    const nextPage = pageNumber < maxNumberOfPages ? pageNumber + 1 : null;

    this.updateTag('prev', previousPage);
    this.updateTag('next', nextPage);

    await this.router.navigate([], {
      queryParams: { page: pageNumber },
      queryParamsHandling: 'merge',
    });
  }

  public destroyPagination() {
    this.linkService.removeTag({ rel: 'prev' });
    this.linkService.removeTag({ rel: 'next' });
  }

  private updateTag(rel: string, page: number | null) {
    if (page === undefined || page === null || Number.isNaN(Number(page))) {
      this.linkService.removeTag({ rel });
      return;
    }

    // add or update querystring of page
    let href = this.router.url;
    const url = this.urlSerializer.parse(href);
    url.queryParams['page'] = page;
    href = this.urlSerializer.serialize(url);

    this.linkService.updateTag({
      rel,
      href,
    });
  }
}
